import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import AppContext from '../../AppContext';

class PrivateRoute extends React.Component {
    render() {
        let { component, ...rest } = this.props;
        let appContext = new AppContext();
        let sessionValid = appContext.getIsSessionValid();

        if (sessionValid !== 'unknown') {
            return (
                <Route {...rest}
                    render={(props) => {
                        let fromPathname = (props && props.location && props.location.pathname);
                        fromPathname = fromPathname || '/';
                        return (
                            sessionValid
                                ?
                                (React.createElement(component, Object.assign({}, props, { ...rest })))
                                :
                                (<Redirect to={`/login?f=${fromPathname}`} />)
                        );
                    }
                    }
                />
            );
        } else {
            return (null);
        }
    }
};
PrivateRoute.propTypes = {
    component: PropTypes.func.isRequired,
};

export default PrivateRoute;